const userRolesFilterEmail = {
  SYSTEM_ADMIN: 'systemAdmin',
  USER_MANAGER: 'userManager',
  REGION_COORDINATOR: 'regionCoordinator',
  LOCATION_COORDINATOR: 'locationCoordinator',
  TEACHER: 'teacher',
};
export default userRolesFilterEmail;
